import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';
import { Button } from './ui/button';
import { Input } from './ui/input';

export const NameInputModal = ({ onComplete }) => {
  const [name, setName] = useState('');

  const handleSubmit = () => {
    const finalName = name.trim() || 'Adventurer';
    localStorage.setItem('anotequest_username', finalName);
    onComplete(finalName);
  };

  return (
    <Dialog open={true} onOpenChange={() => {}}>
      <DialogContent className="max-w-sm" onInteractOutside={(e) => e.preventDefault()}>
        <DialogHeader>
          <DialogTitle className="text-center text-2xl font-semibold tracking-tight">
            what should we call you
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-4 py-4">
          <Input
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="name"
            className="h-11"
            maxLength={20}
            onKeyDown={(e) => e.key === 'Enter' && handleSubmit()}
            autoFocus
          />

          <Button
            size="lg"
            onClick={handleSubmit}
            className="w-full"
          >
            Continue
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default NameInputModal;
